module.exports = __webpack_public_path__ + "img/mash-show.5ecf032a.svg";